import { __decorate, __extends } from "tslib";
import React from 'react';
import CollapsableBase from '../CollapsableBase';
import { observer } from 'mobx-react';
import { Components, Misc } from '@singularsystems/neo-core';
import { NeoReactTypes } from '../../Modules/Types';
var Toast = /** @class */ (function (_super) {
    __extends(Toast, _super);
    function Toast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconFactory = Misc.Globals.appService.get(NeoReactTypes.Components.IconFactory);
        _this.countDownRef = React.createRef();
        return _this;
    }
    Toast.prototype.afterRender = function (isInitial) {
        _super.prototype.afterRender.call(this, isInitial);
        if (this.countDownRef.current) {
            // Countdown. Set the animation time to the timeout.
            this.countDownRef.current.style.transition = "none";
            this.countDownRef.current.style.width = "100%";
            Components.AnimationHelper.triggerReflow(this.countDownRef.current);
            this.countDownRef.current.style.transition = "width linear " + this.props.autoCloseTimeout + "ms";
            Components.AnimationHelper.triggerReflow(this.countDownRef.current);
            this.countDownRef.current.style.width = "0%";
        }
    };
    Toast.prototype.render = function () {
        var _a = this.props, variant = _a.variant, heading = _a.heading, show = _a.show, bindShow = _a.bindShow, icon = _a.icon;
        this.shouldShow = show !== false && (!bindShow || bindShow.value);
        return (React.createElement("div", { className: "toast show collapsable", role: "alert", "aria-live": "assertive", "aria-atomic": "true", ref: this.containerRef },
            React.createElement("div", { className: "toast-header toast-header-" + variant },
                React.createElement("strong", { className: "mr-auto alert-heading" }, heading),
                bindShow && React.createElement("button", { type: "button", className: "ml-2 mb-1 close", "data-dismiss": "toast", "aria-label": "Close", onClick: this.onClose },
                    React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
            this.props.autoCloseTimeout && React.createElement("div", { className: "toast-count-down toast-count-down-" + variant, ref: this.countDownRef }),
            React.createElement("div", { className: "toast-body" },
                icon && React.createElement("div", { className: "notification-icon-container" },
                    this.iconFactory.getIconComponent(icon),
                    React.createElement("div", null, this.props.children)),
                !icon && this.props.children)));
    };
    Toast = __decorate([
        observer
    ], Toast);
    return Toast;
}(CollapsableBase));
export default Toast;
